import CreditSVG from "@/../../hypetrain/static/img/credit.svg";

import EmbedSvg from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { Container } from "@/components/pieces/bootstrap";
import { StyledTitle } from "@/components/pieces/marketing/Titles";
import WhiteBar from "@/components/pieces/marketing/WhiteBar";
import LPLink from "@/components/pieces/upsell/LPLink";
import { BRAND_PURPLE, SITE_NAME } from "@/css/constants";

export default function CreditSystem({
  audience = "D2C",
  whiteBar = false,
  ctaText,
  ctaLink,
  header = null,
  onCtaClick = null,
}) {
  const content = (
    <Container>
      <Flex flexDirection="column" alignItems="center">
        <Box mb={3}>
          <EmbedSvg src={CreditSVG} height={80} width={80} />
        </Box>
        {header ? (
          header
        ) : (
          <>
            <StyledTitle>
              {audience === "D2C"
                ? "Invest In Yourself"
                : "Invest In Your Employees"}
            </StyledTitle>
            <Box maxWidth={700} fontSize={22} textAlign="center" mb={4}>
              {audience === "D2C" ? (
                <>
                  Placement uses a credit-based system. You buy credits and use
                  them to book coaching services. You unlock greater discounts
                  when you buy more credits at a time. That’s right, you get
                  rewarded for committing to investing in yourself.
                </>
              ) : (
                <>
                  {SITE_NAME} uses a credit-based system. You buy credits and
                  distribute them to employees for coaching services. The more
                  credits you purchase at once, the greater the discount! There
                  are no annual contracts or per-employee fees.
                </>
              )}
            </Box>
          </>
        )}
        {ctaText ? (
          <LPLink
            onCtaClick={onCtaClick}
            to={ctaLink}
            color={BRAND_PURPLE}
            text={ctaText}
            style={{
              width: 300,
            }}
          />
        ) : null}
      </Flex>
    </Container>
  );
  return whiteBar ? (
    <WhiteBar>{content}</WhiteBar>
  ) : (
    <Box py={80}>{content}</Box>
  );
}
